import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectWebsiteTheme } from '../../../store/slices/website';

import NoPhoto from '../../../assets/images/no-photo.svg';

import ListingPrice from '../../../components-shared/ListingPrice';
import ListingNotAvailable from '../../../components-shared/ListingNotAvailable';

import {
  Container,
  Photo,
  Description,
  Title,

} from './styled';

const Item = ({ item, websiteId, itemSize }) => {
  const navigate = useNavigate();
  const { colors } = useSelector(selectWebsiteTheme);

  const handleClick = () => {
    navigate(`/${item.listing_id}/details?website_id=${websiteId}`);
  };

  return (
    <Container
      itemSize={itemSize}
      bgColor={colors[2].color}
      onClick={handleClick}
    >
      <Photo
        placeholder={item.images[0]?.medium_url ? 0 : 1}
        image={item.images[0]?.medium_url || NoPhoto}
      />
      <Description>
        <ListingPrice listing={item} noBg />
        <Title>{item.listing_property.display_name}</Title>
      </Description>
      {!item.is_available && <ListingNotAvailable />}
    </Container>
  );
};

Item.propTypes = {
  item: PropTypes.object.isRequired,
  websiteId: PropTypes.string.isRequired,
  itemSize: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
  }).isRequired,
};

export default Item;
